import { useEffect, useState } from "react";

function useTimeElapsed(targetDate: string): number {
  const [elapsedTime, setElapsedTime] = useState<number>();

  useEffect(() => {
    const targetTime = new Date(targetDate).getTime();

    if (isNaN(targetTime)) {
      return;
    }

    const updateElapsedTime = () => {
      const now = Date.now() - targetTime;
      setElapsedTime(now);
    };

    // Initial calculation
    updateElapsedTime();

    // Update every second
    const interval = setInterval(updateElapsedTime, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  return elapsedTime;
}

export default useTimeElapsed;
